import axios from "axios";
import qs from "qs";
import $ from "jquery";
import store from "./index";

import { Subject } from "rxjs";
const subject = new Subject();
var schedulrItems = [];
var paramss = [3137];
var viewer_3d;
var viewer_2d;
var viewer_2d_building;
var backupModel;
const getSubject = () => {
  return subject;
};
const getNewToken = async () => {
  var data = qs.stringify({
    client_id: "DOkCa7I1JTnAhIrFx3xY0EU8lcGbHQFp",
    client_secret: "dbAc7hVJgnmrQPOo",
    grant_type: "client_credentials",
    scope: "viewables:read"
  });
  var config = {
    method: "post",
    url: "https://developer.api.autodesk.com/authentication/v2/token",
    // url: "https://developer.api.autodesk.com/authentication/v1/authenticate",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded"
    },
    data: data
  };
  const response = await axios(config)
    .then(res => {
      return res.data.access_token;
    })
    .catch(e => console.log("Error occured"));

  return response;
};
const createViewer = async (
  inputs = {
    URN: "urn",
    windowElement_3d: null,
    windowElement_2d: null,
    windowElement_2d_building: null,
    strId: null,
    floor: null,
    elevation: null,
    items: [],
    setFocus: false,
    isOptions: true
  }
) => {
  schedulrItems = inputs.items;
  const options = {
    env: "AutodeskProduction",
    accessToken: await getNewToken() // this is just a place holder. i need to store this at
    //a global store to have access to it from anywere and update it from anyware.
  };
  Autodesk.Viewing.Initializer(options, function onInitialized() {
    Autodesk.Viewing.Document.load(
      inputs.URN,
      onDocumentLoadSuccess,
      onDocumentLoadFailure
    );
  });

  function onDocumentLoadSuccess(doc) {
    // A document contains references to 3D and 2D viewables.
    if (inputs.windowElement_3d != null) {
      var viewables_3d = Autodesk.Viewing.Document.getSubItemsWithProperties(
        doc.getRootItem(),
        {
          type: "geometry",
          role: "3d"
        },
        true
      );
    }
    if (inputs.windowElement_2d != null && inputs.elevation == undefined) {
      var viewables_2d_building = Autodesk.Viewing.Document.getSubItemsWithProperties(
        doc.getRootItem(),
        {
          type: "view",
          role: "2d"
        },
        true
      );
    }
    if (inputs.windowElement_2d != null && inputs.elevation != undefined) {
      var viewables_2d_building = Autodesk.Viewing.Document.getSubItemsWithProperties(
        doc.getRootItem(),
        {
          type: "view",
          role: "2d",
          name: "Elevation:" + " " + inputs.elevation
        },
        true
      );
    }
    if (inputs.windowElement_2d_building != null && inputs.floor == undefined) {
      var viewables_2d = Autodesk.Viewing.Document.getSubItemsWithProperties(
        doc.getRootItem(),
        {
          type: "geometry",
          role: "2d"
        },
        true
      );
    }
    if (inputs.windowElement_2d_building != null && inputs.floor != undefined) {
      var viewables_2d = Autodesk.Viewing.Document.getSubItemsWithProperties(
        doc.getRootItem(),
        {
          type: "geometry",
          role: "2d",
          name: inputs.floor
        },
        true
      );
    }

    // if (viewables_3d.length === 0) {
    //   console.error("Document contains no viewables.");
    //   return;
    // }
    if (viewables_3d != undefined) {
      var initialViewable_3d = viewables_3d[0];
    }
    if (viewables_2d != undefined) {
      var initialViewable_2d = viewables_2d[0];
    }
    if (viewables_2d_building != undefined) {
      var initialViewable_2d_buidling = viewables_2d_building[0];
    }
    if (viewables_3d != undefined && initialViewable_3d != undefined) {
      var svfUrl_3d = doc.getViewablePath(initialViewable_3d);
    }
    if (viewables_2d != undefined && initialViewable_2d != undefined) {
      var svfUrl_2d = doc.getViewablePath(initialViewable_2d);
    }
    if (
      viewables_2d_building != undefined &&
      initialViewable_2d_buidling != undefined
    ) {
      var svfUrl_2d_building = doc.getViewablePath(initialViewable_2d_buidling);
    }

    const modelOptions = {
      sharedPropertyDbPath: doc.getPropertyDbPath()
    };

    viewer_3d = new window.Autodesk.Viewing.Private.GuiViewer3D(
      inputs.windowElement_3d
    );
    viewer_2d = new window.Autodesk.Viewing.Private.GuiViewer3D(
      inputs.windowElement_2d
    );
    viewer_2d_building = new window.Autodesk.Viewing.Private.GuiViewer3D(
      inputs.windowElement_2d_building
    );
    if (viewables_3d != undefined) {
      viewer_3d.start(
        svfUrl_3d,
        modelOptions,
        onLoadModelSuccess,
        onLoadModelError
      );
    }
    if (viewables_2d != undefined) {
      viewer_2d.start(
        svfUrl_2d,
        modelOptions,
        onLoadModelSuccess,
        onLoadModelError
      );
    }
    if (viewables_2d_building != undefined) {
      viewer_2d_building.start(
        svfUrl_2d_building,
        modelOptions,
        onLoadModelSuccess,
        onLoadModelError
      );
    }
    // viewer_3d.fitToView(3137);
    viewer_3d.addEventListener(
      Autodesk.Viewing.SELECTION_CHANGED_EVENT,
      function(args) {
        //   var instanceTree = viewer_3d.model.getData().instanceTree
        //   var rootId = instanceTree.getRootId();
        //  viewer_3d.impl.visibilityManager.setNodeOff(rootId, false);
        if (args.dbIdArray.length > 1) {
          let uuid = args.dbIdArray;
        } else {
          let uuid = args.dbIdArray[0];
          if (uuid != undefined) {
            for (let i = 0; i < inputs.items.length; i++) {
              viewer_3d.search("[" + inputs.items[i].strID + "]", function(
                params
              ) {
                schedulrItems[i].uuid = params[0];
                if (schedulrItems[i].uuid == uuid) {
                  schedulrItems[i].isFocused = true;
                  console.log("focused uuid", schedulrItems[i]);

                  subject.next(i);
                  // $("tr:contains('" + schedulrItems[i].strID + "')").trigger("focus");
                } else {
                  schedulrItems[i].isFocused = false;
                }
              });
            }
          }
          inputs.strId = null;
        }

        // viewer_3d.fitToView(3137);
        //for testing purpose
        // schedulrItems[0].isFocused=true;

        //

        // viewer_3d.search(
        //   inputs.strId,
        //   function(params) {
        //     console.log("this is params", params);
        //     viewer_3d.fitToView(params);
        //   },
        //   console.log
        // );
      }
    );
    viewer_3d.addEventListener(
      Autodesk.Viewing.SELECTION_CHANGED_EVENT,
      function(args) {
        let uuid = args.dbIdArray[0];

        if (uuid != undefined) {
          viewer_3d.search(
            inputs.strId,
            function(params) {
              console.log("this is params", params);
              viewer_3d.fitToView(params);
            },
            console.log
          );
        }
      }
    );
    //viewer_2d.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, function(
    //  args
    //) {
    //  viewer_2d.search(
    //    inputs.strId,
    //    function(params) {
    //      alert("this is params", params);
    //      viewer_2d.fitToView(params);
    //    },
    //    console.log
    //  );
    //});
    viewer_2d.addEventListener(
      Autodesk.Viewing.SELECTION_CHANGED_EVENT,
      function(args) {
        let uuid = args.dbIdArray[0];

        if (uuid != undefined) {
          viewer_2d.search(inputs.strId, function(params) {
            console.log("this is params", params);
            viewer_2d.fitToView(params);
            //	viewer_2d.select(params, "Autodesk.Viewing.SelectionMode.REGULAR");
          });
        }
      }
    );

    viewer_2d_building.addEventListener(
      Autodesk.Viewing.SELECTION_CHANGED_EVENT,
      function(args) {
        let uuid = args.dbIdArray[0];

        if (uuid != undefined) {
          viewer_2d_building.search(inputs.strId, function(params) {
            console.log("this is params", params);
            viewer_2d_building.fitToView(params);
            viewer_2d_building.select(
              params,
              "Autodesk.Viewing.SelectionMode.REGULAR"
            );
          });
        }
      }
    );
  }
  function onDocumentLoadFailure(viewerErrorCode) {
    // console.error("onDocumentLoadFailure() - errorCode:" + viewerErrorCode);
  }
  function onLoadModelSuccess(model) {
    if (inputs.isOptions == false) {
      viewer_3d.toolbar._controls = [];
      viewer_2d.toolbar._controls = [];
      viewer_2d_building.toolbar._controls = [];
    }

    console.log("onLoadModelSuccess()!");
    store.commit("setModelInfo", model.getData());
    // console.log("Validate model loaded: " + (viewer.model === model));
    console.log(model.getData());
    if (inputs.setFocus == true) {
      viewer_3d.search(inputs.strId, function(params) {
        //itemsUui.push(params);
        //viewer_3d.isolate(params);
        //    backupModel=viewer_3d;
        //   var instanceTree = viewer_3d.model.getData().instanceTree
        //   var rootId = instanceTree.getRootId()
        //  viewer_3d.hide(rootId);

        //viewer_3d.impl.visibilityManager.setNodeOff(rootId, true);

        // let red = new THREE.Vector4(1, 0, 0, 1);
        // viewer_3d.setThemingColor( params, red, model );
        viewer_3d.fitToView(params);
      });
      // inputs.strId=null;
    }
  }
  function onLoadModelError(viewerErrorCode) {
    // console.error("onLoadModelError() - errorCode:" + viewerErrorCode);
  }
};

export {
  getNewToken,
  createViewer,
  getSubject,
  viewer_3d,
  viewer_2d,
  viewer_2d_building
};
